import { render, staticRenderFns } from "./IconSadFace.vue?vue&type=template&id=a6476e76&"
import script from "./IconSadFace.vue?vue&type=script&lang=js&"
export * from "./IconSadFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports